import {AssetStatus, type IAsset} from '@netx/core-asset-next/schema';

const PRESENT_STATUSES = [
	AssetStatus.NEARLINE,
	AssetStatus.ONLINE,
	AssetStatus.TEMP,
];

export const assetIsPresent = (asset: Pick<IAsset, 'status'>) =>
	PRESENT_STATUSES.includes(asset.status);

export default assetIsPresent;
